import { DataExports } from '@/backoffice/features/data-exports/data-exports';
import { TCustomRouteObject } from '@/shared/types/router.types';

export const dataExportRoutes: TCustomRouteObject = {
  path: 'data-exports',
  Component: () => <DataExports />,
  handle: {
    crumb: {
      label: 'data_exports',
      localized: true,
    },
    permission: { action: 'backofficeTenant:exportTenantBilling' },
  },
};
